import type {
  DeliveryStatus,
  HighlighterStatus,
  HlSurveyType,
  PointTransactionReason,
  PointTransactionType,
} from './rtk/rtk.generated';

export const SURVEY_STATUS = {
  NotSent: 'not sent',
  Sent: 'sent',
  Started: 'started',
  Completed: 'completed',
  Expired: 'expired',
  Cancelled: 'cancelled',
  Overdue: 'overdue', //? Overdue only applies to Item Surveys and One-Off Surveys
  Disqualified: 'disqualified',
  Declined: 'declined',
  PendingResponse: 'pending response',
  FailedQc: 'failed qc',
} as const;

export const SURVEY_INSTANCE_RESPONSE_STATUS = {
  Success: 'success',
  Failed: 'failed',
} as const;

export const SURVEY_ACTION = {
  Cancel: 'Cancel',
  Expire: 'Expire',
  Nudge: 'Nudge',
} as const;

export const HighlighterStatuses: HighlighterStatus[] = [
  'active',
  'banned',
  'disabled',
  'new',
  'stale',
  'quit',
];

export const PointReasons: PointTransactionReason[] = [
  'optin',
  'projectcomplete',
  'other',
  'photo',
  'video',
  'idi',
];
export const PointTypes: PointTransactionType[] = ['add', 'withdraw'];

export const STUDY_STEP_TYPE = {
  NOOP: 'noop',
  WAITING: 'waiting',
  SURVEY: 'survey',
} as const;

export const SURVEY_TYPE = {
  ITEM: 'itemSurvey',
  OPT_IN: 'optInSurvey',
  ONE_OFF: 'oneOff',
  PROFILE: 'profileSurvey',
} as const;

export const SURVEY_TYPE_DISPLAY: Record<HlSurveyType, string> = {
  itemSurvey: 'Item',
  optInSurvey: 'Opt-In',
  oneOff: 'One-Off',
  profileSurvey: 'Profile',
} as const;

export const SURVEY_LINK_MAP: Record<HlSurveyType, string> = {
  itemSurvey: 'item-survey',
  optInSurvey: 'optin-survey',
  oneOff: 'oneoff-survey',
  profileSurvey: 'profile-survey',
} as const;

export const DELIVERY_STATUS = {
  NotAssigned: 'NotAssigned',
  InfoReceived: 'InfoReceived',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  AttemptFail: 'AttemptFail',
  Delivered: 'Delivered',
  Received: 'Received',
  AvailableForPickup: 'AvailableForPickup',
  Exception: 'Exception',
  Expired: 'Expired',
  Pending: 'Pending',
} as const satisfies Record<DeliveryStatus, DeliveryStatus>;

export const BOX_DELIVERY_STATUS_DISPLAY: Record<DeliveryStatus, string> = {
  NotAssigned: 'Not Assigned',
  InfoReceived: 'Info Received',
  InTransit: 'In Transit',
  OutForDelivery: 'Out for Delivery',
  AttemptFail: 'Attempt Fail',
  Delivered: 'Delivered',
  Received: 'Received',
  AvailableForPickup: 'Available for Pickup',
  Exception: 'Exception',
  Expired: 'Expired',
  Pending: 'Pending',
} as const;
